var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_389_184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 7H7.66667C6.95942 7 6.28115 7.28095 5.78105 7.78105C5.28095 8.28115 5 8.95942 5 9.66667V25.6667C5 26.3739 5.28095 27.0522 5.78105 27.5523C6.28115 28.0524 6.95942 28.3333 7.66667 28.3333H15.2627",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 18.666V23.9993H29.3333",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9993 14.666V9.33268C23.9993 8.62544 23.7184 7.94716 23.2183 7.44706C22.7182 6.94697 22.0399 6.66602 21.3327 6.66602H18.666",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.666 6.66667C10.666 5.95942 10.947 5.28115 11.4471 4.78105C11.9472 4.28095 12.6254 4 13.3327 4H15.9993C16.7066 4 17.3849 4.28095 17.885 4.78105C18.3851 5.28115 18.666 5.95942 18.666 6.66667C18.666 7.37391 18.3851 8.05219 17.885 8.55229C17.3849 9.05238 16.7066 9.33333 15.9993 9.33333H13.3327C12.6254 9.33333 11.9472 9.05238 11.4471 8.55229C10.947 8.05219 10.666 7.37391 10.666 6.66667Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.666 23.9993C18.666 25.4138 19.2279 26.7704 20.2281 27.7706C21.2283 28.7708 22.5849 29.3327 23.9993 29.3327C25.4138 29.3327 26.7704 28.7708 27.7706 27.7706C28.7708 26.7704 29.3327 25.4138 29.3327 23.9993C29.3327 22.5849 28.7708 21.2283 27.7706 20.2281C26.7704 19.2279 25.4138 18.666 23.9993 18.666C22.5849 18.666 21.2283 19.2279 20.2281 20.2281C19.2279 21.2283 18.666 22.5849 18.666 23.9993Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.666 14.666H15.9993",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.666 20H14.666",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_389_184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidation);
export default __webpack_public_path__ + "static/media/validation.8d2e8509d6901321c2aae2bdf6ca9707.svg";
export { ForwardRef as ReactComponent };